import clsx from 'clsx'

export interface INavItemClassNameOptions {
  /** Свёрнутое меню: пункт превращается в квадратную кнопку, как «свернуть/развернуть» */
  collapsed?: boolean
  /** Вложенный пункт группы */
  nested?: boolean
  /** Пункт на светлой подложке — например, в поповере свёрнутого меню */
  light?: boolean
  /** Текущий маршрут или раскрытый поповер группы */
  active?: boolean
}

export const getNavItemClassName = ({
  collapsed = false,
  nested = false,
  light = false,
  active = false,
}: INavItemClassNameOptions = {}) =>
  clsx('flex items-center gap-[8px] whitespace-nowrap rounded-[8px] text-left transition-none', {
    ['text-white opacity-60 hover:text-[#40DDB8] hover:opacity-100']: !light && !active,
    // hover дублирует активный цвет: иначе на ссылке побеждает глобальный a:hover из antd
    ['text-[#40DDB8] opacity-100 hover:text-[#40DDB8]']: !light && active,
    ['text-focus-500 hover:text-default']: light && !active,
    ['text-default hover:text-default']: light && active,
    // фон под курсором одинаковый и в свёрнутом, и в развёрнутом меню
    ['hover:bg-[#8D7CA71F] hover:opacity-100']: !light,
    // в поповере подложка светлая — берём фон светлых выпадающих списков
    ['hover:bg-default-200']: light,
    // иконка бледнее подписи; под курсором и у активного пункта — в полную силу
    ['[&_svg]:opacity-70 [&:hover_svg]:opacity-100']: !active,
    ['h-[44px] w-[44px] justify-center']: collapsed,
    ['bg-[#8D7CA71F]']: collapsed && active,
    ['pl-[12px]']: !collapsed,
    ['text-[13px] h-[32px]']: nested,
    ['text-[15px] min-h-[44px] h-[44px]']: !nested,
  })
